<template>
  <div
    class="fixed sm:bottom-5 bottom-0 right-0 sm:right-5 z-9999 flex flex-col space-y-3 w-full sm:w-auto px-2.5 sm:px-0"
  >
    <TransitionGroup name="list">
      <div
        v-for="t in toastStore.toasts"
        :key="t.id"
        :class="[
          getMessageClasses(t.type),
          'px-4 py-3 flex justify-between items-center space-x-3 text-white shadow-lg transition-all duration-300 sm:rounded-lg min-w-75',
        ]"
      >
        <div class="flex items-center space-x-2">
          <Icon :name="getIcon(t.type)" size="24" class="mt-0.5 shrink-0" />
          <p class="sm:text-base text-sm font-medium">
            {{ t.message }}
          </p>
        </div>

        <button
          @click="toastStore.remove(t.id)"
          class="text-white opacity-90 hover:opacity-100 transition-opacity flex items-center justify-center cursor-pointer"
        >
          <Icon name="ph:x" size="18" weight="bold" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useMessage } from "~/stores/app-toast";

const toastStore = useMessage();

// Colors from source 2
const getMessageClasses = (type: string) => {
  switch (type) {
    case "error":
      return "bg-red-400";
    case "success":
      return "bg-green-600";
    case "info":
    default:
      return "bg-amber-700";
  }
};

// Icons from source 2
const getIcon = (type: string) => {
  switch (type) {
    case "error":
      return "ph:warning-circle";
    case "success":
      return "ph:check-circle";
    case "info":
    default:
      return "ph:info";
  }
};
</script>

<style scoped>
/* Animation Logic from source 1 */
.list-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.list-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

/* Ensure moving items animate smoothly */
.list-move {
  transition: transform 0.4s ease;
}
</style>
